import { render, staticRenderFns } from "./CiVehicleDetailsTooltip.vue?vue&type=template&id=e245c648&"
import script from "./CiVehicleDetailsTooltip.vue?vue&type=script&lang=js&"
export * from "./CiVehicleDetailsTooltip.vue?vue&type=script&lang=js&"
import style0 from "./CiVehicleDetailsTooltip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports